import React from "react";
import "./Button.scss";

const NoramlButton = (props) => {
  const {
    className = "",
    label = "",
    onClick,
    onSubmit,
    id,
    type = "submit",
    disabled = false,
    rightIcon = "",
    children
  } = props;

  return (
    <>
      <button
        id={id}
        type={type}
        className={`${className}  ${disabled && "cursor-not-allowed"}`}
        onClick={onClick}
        disabled={disabled}
        onSubmit={onSubmit}
      >
        {label || children}
        {rightIcon !== "" ? (
          <span className={`btn-right-icon ${rightIcon}`}></span>
        ) : null}
      </button>
    </>
  );
};

export default NoramlButton;
